// vista#792: the vocabulary moved to `lib/statusColor.js`. It was duplicated
// here and (narrower, missing `up`) in `Topology.jsx`, which is why the agent
// node's dot was grey while its state was `up`.
import { statusStyle, statusDot } from '../../lib/statusColor.js';

export default function StatusBadge({ status, label }) {
  const style = statusStyle(status);
  const dot = statusDot(status);
  const text = label || status;

  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium ${style}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${dot}`} />
      {text}
    </span>
  );
}
